import { Autocomplete, TextField } from '@mui/material';
import { type SyntheticEvent } from 'react';

import { type VaSearchInput } from '../../../dtos';
import { trpc } from '../../../trpc';
import { type FilterCallback } from '../types';

type FacetFilterProps = {
  readonly label: string;
  readonly field: 'sapstatus' | 'geschaeftsbereich' | 'klassifizierung' | 'buchungsnummer' | 'ortkuerzel';
  readonly searchParams: VaSearchInput;
  readonly filterCallback: FilterCallback;
};

type FilterOption = {
  label: string;
  count: number;
};

export const FacetFilterSelect: React.FC<FacetFilterProps> = (props: FacetFilterProps) => {
  const optionsQuery = trpc.veranstaltung.getVeranstaltungSearchFacetOptions.useQuery({ field: props.field });

  const handleChange = (_: SyntheticEvent, values: FilterOption[]): void => {
    props.filterCallback({ [props.field]: values.map((item) => item.label) });
  };

  return (
    <Autocomplete
      disablePortal
      options={optionsQuery.data ?? []}
      fullWidth
      isOptionEqualToValue={(value, option) => value.label === option.label}
      multiple
      onChange={handleChange}
      renderInput={(params) => <TextField variant="standard" {...params} label={props.label} />}
    />
  );
};
